import {EntityService} from 'src/service/EntityService';

export class AgreementTemplateService extends EntityService {

  static entity = 'iam-main/template-agreements';

  static update(id: string, data: any): Promise<any> {
    return this.axios.post(`${this.entity}/${id}/update`, data).then(res => res.data);
  }

  static getFormFieldTypes(): Promise<any> {
    return this.axios.get(`iam-common/agreement-form-field-types`).then(res => res.data);
  }


  static getFormFields(agreementId: string): Promise<any> {
    return this.axios.get(`${this.entity}/${agreementId}/formFields`).then(res => res.data);
  }

  static setFormFields(agreementId: string, dbFormFields: Array<any>): Promise<any> {
    return this.axios.put(`${this.entity}/${agreementId}/formFields`, {dbFormFields}).then(res => res.data);
  }

  static getAgreementList(disabled: string,lazyLoadEvent: string, params?: any): Promise<any> {
    return this.axios.get(`${this.entity}/list?disabled=${disabled}&lazyLoadEvent=${lazyLoadEvent}`, {params}).then(res => res.data);
  }
  static getOrderItemPrototypeFields(): Promise<any> {
    return this.axios.get(`${this.entity}/prototype-fields`).then(res => res.data);
  }
  static getPDFFile(agreementId:string): Promise<any> {
    return this.axios.get(`${this.entity}/${agreementId}/download-pdf`).then(res => res.data);
  }

  // Upload Excel để tạo hàng loạt tài liệu
  static uploadExcel(agreementId: string, formData: FormData): Promise<any> {
    return this.axios.post(`${this.entity}/${agreementId}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
  }

  // Tải file Excel mẫu
  static downloadTemplate(agreementId: string): void {
    window.open(`${this.baseURL}/${this.entity}/${agreementId}/download-template`);
  }

}